"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("../../Services/service.service");
var forms_1 = require("@angular/forms");
var subscribtion_service_1 = require("../../Services/subscribtion.service");
var angular_cc_library_1 = require("angular-cc-library");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["PremiumAdToken"] = 0] = "PremiumAdToken";
    PaymentType[PaymentType["WriteAdToken"] = 1] = "WriteAdToken";
    PaymentType[PaymentType["ThirdPartyToken"] = 2] = "ThirdPartyToken";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PremiumAdTokenPayment = /** @class */ (function () {
    function PremiumAdTokenPayment(service, fb, subscribtionService) {
        this.service = service;
        this.fb = fb;
        this.subscribtionService = subscribtionService;
        this.creating = false;
        this.paymentFormType = PaymentType.PremiumAdToken;
        this.payButtonText = "";
        this.onTokenAdded = new core_1.EventEmitter();
        this._termsNotAccepted = true;
    }
    Object.defineProperty(PremiumAdTokenPayment.prototype, "termsNotAccepted", {
        get: function () {
            return this._termsNotAccepted;
        },
        set: function (value) {
            this._termsNotAccepted = value;
        },
        enumerable: true,
        configurable: true
    });
    PremiumAdTokenPayment.prototype.ngOnInit = function () {
        this.form = this.fb.group({
            firstName: ['', [forms_1.Validators.required]],
            lastName: ['', [forms_1.Validators.required]],
            zip: ['', [forms_1.Validators.required]],
            creditCard: ['', [angular_cc_library_1.CreditCardValidator.validateCCNumber]],
            expirationDateYear: ['', [forms_1.Validators.required]],
            expirationDateMonth: ['', [forms_1.Validators.required]],
            cvc: ['', [forms_1.Validators.required, forms_1.Validators.minLength(3), forms_1.Validators.maxLength(4)]],
        });
    };
    Object.defineProperty(PremiumAdTokenPayment.prototype, "isThirdPartyPayment", {
        get: function () {
            return this.paymentFormType == PaymentType.ThirdPartyToken;
        },
        enumerable: true,
        configurable: true
    });
    PremiumAdTokenPayment.prototype.onSubmitPremiumAdToken = function () {
        var _this = this;
        if (this.form.dirty && this.form.valid) {
            var data = new WickedApiClient_1.AddPremiumAdToken({
                firstName: this.form.controls["firstName"].value,
                lastName: this.form.controls["lastName"].value,
                cardNumber: this.form.controls["creditCard"].value,
                expirationDate: this.form.controls["expirationDateYear"].value + "-" + this.form.controls["expirationDateMonth"].value,
                zip: this.form.controls["zip"].value,
                securityCode: this.form.controls["cvc"].value,
            });
            this.creating = true;
            this.subscribtionService.createPremiumAdToken(data).then(function (response) {
                _this.creating = false;
                _this.onTokenAdded.emit(response);
            });
        }
    };
    PremiumAdTokenPayment.prototype.onSubmitWriteAdToken = function () {
        var _this = this;
        if (this.form.dirty && this.form.valid) {
            var data = new WickedApiClient_1.AddWriteAdToken({
                firstName: this.form.controls["firstName"].value,
                lastName: this.form.controls["lastName"].value,
                cardNumber: this.form.controls["creditCard"].value,
                expirationDate: this.form.controls["expirationDateYear"].value + "-" + this.form.controls["expirationDateMonth"].value,
                zip: this.form.controls["zip"].value,
                securityCode: this.form.controls["cvc"].value,
            });
            this.creating = true;
            this.subscribtionService.createWriteAdToken(data).then(function (response) {
                _this.creating = false;
                _this.onTokenAdded.emit(response);
            });
        }
    };
    PremiumAdTokenPayment.prototype.onSubmitThirdPartyAdToken = function () {
        var _this = this;
        if (this.form.dirty && this.form.valid) {
            if (!this.termsNotAccepted) {
                var data = new WickedApiClient_1.AddPremiumAdToken({
                    firstName: this.form.controls["firstName"].value,
                    lastName: this.form.controls["lastName"].value,
                    cardNumber: this.form.controls["creditCard"].value,
                    expirationDate: this.form.controls["expirationDateYear"].value + "-" + this.form.controls["expirationDateMonth"].value,
                    zip: this.form.controls["zip"].value,
                    securityCode: this.form.controls["cvc"].value,
                });
                this.creating = true;
                this.subscribtionService.createThirdPartyAdToken(data).then(function (response) {
                    _this.creating = false;
                    _this.onTokenAdded.emit(response);
                });
            }
            else {
                this.service.showError("Please accept terms");
            }
        }
    };
    PremiumAdTokenPayment.prototype.onSubmit = function () {
        switch (this.paymentFormType) {
            case PaymentType.PremiumAdToken:
                this.onSubmitPremiumAdToken();
                break;
            case PaymentType.WriteAdToken:
                this.onSubmitWriteAdToken();
                break;
            case PaymentType.ThirdPartyToken:
                this.onSubmitThirdPartyAdToken();
                break;
        }
    };
    PremiumAdTokenPayment.prototype.termsAcceptAction = function (e) {
        this.termsNotAccepted = !e.checked;
    };
    return PremiumAdTokenPayment;
}());
exports.PremiumAdTokenPayment = PremiumAdTokenPayment;
